import 'dayjs/locale/ar';
import 'dayjs/locale/es';
import 'dayjs/locale/he';

import { createInstance, i18n as I18nInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import arCommon from './locales/ar/common.json';
import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import heCommon from './locales/he/common.json';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES, SupportedLocale } from './settings';

const resources = {
  en: { common: enCommon },
  he: { common: heCommon },
  ar: { common: arCommon },
  es: { common: esCommon },
};

const createI18nInstance = (locale: SupportedLocale): I18nInstance => {
  const instance = createInstance();
  instance.use(initReactI18next).init({
    resources,
    lng: locale,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    defaultNS: 'common',
    ns: ['common'],
    interpolation: {
      // react already escapes interpolated values
      escapeValue: false,
    },
    initImmediate: false,
    react: {
      useSuspense: false,
    },
  });
  return instance;
};

let clientInstance: I18nInstance | undefined;

/**
 * Server: a fresh instance per request so concurrent requests in different
 * languages never bleed into each other.
 * Client: a singleton that survives client-side navigation; the locale is
 * only changed explicitly (language switcher / geo fallback).
 */
export const getI18nInstance = (locale: SupportedLocale): I18nInstance => {
  if (typeof window === 'undefined') {
    return createI18nInstance(locale);
  }
  if (!clientInstance) {
    clientInstance = createI18nInstance(locale);
  }
  return clientInstance;
};
